import React from "react";

const KeyProjects = () => {
  const projects = [
    {
      id: 1,
      description:
        "Survey Investigation & preparation of DPR for R&B division Deogarh (05 no Road).",
      animation: "fade-up",
    },
    {
      id: 2,
      description:
        "Quality Control for NH 326 (Malkangir Jeypore) & 326A (Paralakhemundi) for Superintending Engineer, NH circle (South), Berhampur.",
      animation: "fade-right",
    },
    {
      id: 3,
      description: "Sub-soil Exploration for NALCO, Damanjodi, Koraput.",
      animation: "fade-left",
    },
    {
      id: 4,
      description:
        "NDT both Rebound Hammer & UPV for Mahanadi HL Bridge Athamallik-Dhalpur of Angul / Boudh District (Client- Ranjit Buildcon).",
      animation: "zoom-in",
    },
    {
      id: 5,
      description:
        "Survey & Sub-soil Exploration for construction of EMRS various locations in Odisha (Client- HSCL, Bhubaneswar).",
      animation: "flip-up",
    },
    {
      id: 6,
      description:
        "Geo-Technical Investigation for Major Bridges (1RB & 90A) of Angul-Sukinda New B.G Rail link project of East Coast Railway (Client- RVNL, Bhubaneswar).",
      animation: "flip-left",
    },
  ];

  return (
    <React.Fragment>
      {/* <div className="py-12 md:mx-16 mx-6">
        <h1 className="text-3xl lg:text-5xl font-semibold text-center mb-4">
          Key Projects
        </h1>
        <div className="grid lg:grid-cols-2 grid-cols-1 md:mt-14 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="relative md:py-16 py-8 px-6 text-center border rounded-lg shadow-md"
              data-aos={project.animation} // Different AOS animation for each project
            >
              <div className="absolute -top-5 right-6 bg-blue-600 text-white rounded-full w-10 h-10 lg:w-14 lg:h-14 text-2xl lg:text-4xl flex items-center justify-center">
                {project.id}
              </div>
              <p className="text-base md:text-md lg:text-md 2xl:text-xl">
                {project.description}
              </p>
            </div>
          ))}
        </div>
      </div> */}
      <div className="py-12 md:mx-16 mx-6">
        <div className="md:max-w-[70%] mx-auto text-center">
          <h1 className="text-3xl lg:text-5xl font-semibold text-center mb-4">
            Key Projects
          </h1>
        </div>
        {/* <div className="grid lg:grid-cols-2 grid-cols-1 mt-7 md:mt-14 gap-8">
                    {projects.map((project) => (
                        <div
                            key={project.id}
                            className="relative md:py-16 py-8 px-6 text-center border rounded-lg shadow-md"
                            data-aos={project.animation} // Apply different AOS animation
                        >
                            <div style={{ fontFamily: "Oregano, cursive" }} className="absolute -top-5 right-6 bg-blue-600 text-white rounded-full w-10 h-10 lg:w-14 lg:h-14 text-2xl lg:text-4xl flex items-center justify-center">
                                {project.id}
                            </div>
                            <p className='text-base md:text-md lg:text-md 2xl:text-xl'>{project.description}</p>
                        </div>
                        
                    ))}
                </div> */}

        {/* <div className="mt-7 md:mt-14">
          {projects.map((project) => (
            <ol
              key={project.id}
              className="py-2 px-6 text-start list-none flex items-center gap-2"
              data-aos={project.animation} // Apply different AOS animation
            >
              <li className="before:content-['*'] before:mr-2 before:font-bold text-xl"></li>
              <li className=" text-base md:text-md lg:text-md 2xl:text-xl">
                {project.description}
              </li>
            </ol>
          ))}
        </div> */}
        <div className="mt-7 md:mt-10">
          {projects.map((project) => (
            <ol
              key={project.id}
              className="py-2 px-6 text-start list-none "
              data-aos={project.animation} // Apply different AOS animation
            >
              <li className="before:content-['*'] before:mr-2 before:font-bold text-base md:text-sm lg:text-lg font-medium">
                {project.description}
              </li>
            </ol>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default KeyProjects;
